import styled, { createGlobalStyle } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const GlobalPopupStyles = createGlobalStyle`
    .activation_setup_modal_popup_styles {
        background-color: transparent;
        border: unset;
        box-shadow: unset;
    }

    .activation_setup_modal_popup_content_styles {
        padding: 12px 0 0;
    
        &:has(.ListItemsContainer) {
            border-bottom: 1px solid ${colorsPalettes.carbon[50]};
            border-radius: 4px;
            box-shadow: 0 3px 5px 0 rgba(42, 62, 82, 0.12);
            padding-top: 7px;
        }
    }
`;

export const StyledIConButton = styled(IconButton)`
    height: 36px !important;
`;
